const MONTHLY_DATE_CHECK = 8

const handleData = (room, bills_data, chosen_month) => {
    const data_by_room_id = bills_data.find(bill => bill.room_id === room.room_id)
    const bills_by_room_id = data_by_room_id ? data_by_room_id.bills : []
    if (bills_by_room_id.length > 0){
        // bills_by_room_id.sort((a,b)=> dayDiff(a.date_check, b.date_check))
        const newest_contract_id = bills_by_room_id[0].contract_id;
        const bills_by_newest_contract = bills_by_room_id.
            filter(bill => bill.contract_id === newest_contract_id)
            .slice(0);
        if (bills_by_newest_contract.length === 2) {
            const month = Number(chosen_month.split('-')[1])
            const bills_by_newest_contract_chosen_month = bills_by_newest_contract.filter(bill => {
                const month_check = new Date(bill.date_check).getMonth() + 1
                return month == month_check
            })
            if (bills_by_newest_contract_chosen_month.length){
                room.note = bills_by_newest_contract_chosen_month[0].note;
                room.end_count = bills_by_newest_contract_chosen_month[0].lock_payment_count || bills_by_newest_contract_chosen_month[0].count;
                room.end_count_id = bills_by_newest_contract_chosen_month[0]._id;
                room.start_count = bills_by_newest_contract_chosen_month[1] ?
                    bills_by_newest_contract_chosen_month[1].count :
                    bills_by_newest_contract[1].count;
                room.start_count_id = bills_by_newest_contract_chosen_month[1] ?
                    bills_by_newest_contract_chosen_month[1]._id :
                    bills_by_newest_contract[1]._id;
                room.end_count_old = room.end_count;
                room.is_disabled = true;
            } else {
                room.note = bills_by_newest_contract[0] ? bills_by_newest_contract[0].note : '';
                room.start_count = bills_by_newest_contract[0] ? bills_by_newest_contract[0].count : '';
                room.start_count_id = bills_by_newest_contract[0] ? bills_by_newest_contract[0]._id : '';;
            }
        } else {
            const bill_0 = bills_by_newest_contract[0]
            if (bill_0 && bill_0.check_in_id && new Date(bill_0.date_check).getDate() >= MONTHLY_DATE_CHECK){
                room.end_count = bill_0.count;
            }
            room.note = bill_0 ? bill_0.note : '';
            room.start_count = bill_0 ? bill_0.count : '';
            room.start_count_id = bill_0 ? bill_0._id : '';;
        }
        room.diff = room.end_count - room.start_count > 0 ? room.end_count - room.start_count : 0;
        room.washing_machine = data_by_room_id.devices.find(device => device.type === "WM");
        room.air_conditioner = data_by_room_id.devices.find(device => device.type === "AC");
        room.customer_count = data_by_room_id.customer_count;
        room.is_valid_contract = data_by_room_id.is_valid_contract;
        room.monthly_usage_average = data_by_room_id.monthly_usage_average;
    }
    return room
}

export {
    handleData
}